import { Component, Input, OnInit, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { VerbatimService } from 'src/app/shared/services/verbatim/verbatim.service';
import * as _ from 'lodash';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DoughnutChartData } from '../../../doughnut-view/doughnut-chart-data.interface';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import * as moment from 'moment';
import { map, of, Subscription, Observable } from 'rxjs';
import { NgIf, NgClass, NgFor, NgStyle } from '@angular/common';
import { DoughnutViewComponent } from '../../../doughnut-view/doughnut-view.component';
import { ScoreLineChartComponent } from '../../../score/score-line-chart/score-line-chart.component';
import { LtmsDataTableV2Component } from '../../../ltms-data-table-v2/ltms-data-table-v2.component';
import { LtmsErrorComponent } from '../../../ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../../../ltms-loader/ltms-loader.component';

@Component({
    selector: 'app-relationship-view-panel',
    templateUrl: './relationship-view-panel.component.html',
    styleUrls: ['./relationship-view-panel.component.scss'],
    imports: [
        NgIf,
        NgClass,
        DoughnutViewComponent,
        ScoreLineChartComponent,
        LtmsDataTableV2Component,
        NgFor,
        NgStyle,
        LtmsErrorComponent,
        LtmsLoaderComponent,
    ]
})
export class RelationshipViewPanelComponent implements OnInit {
  // lineChartId = 'relationship_view' + new Date().getTime();
  private subscriptions: Subscription = new Subscription()
  fullScreenComponent: TemplateRef<any> | null = null;
  isFullScreen: boolean = false;
  isTSEnabled: boolean = false;
  helpersResponse: any = {};
  lineChartDiscription: any = "demo contain"
  commonPayload: any = {};
  @Input() feedData: any = [];
  @Input() yAxisMin: number = 0; // Default value for Y-axis minimum
  @Input() xAxisFontColor: string = '#FF0000'; // Default value for X-axis font color
  relationshipTimeline: any = [];
  activeTab: string = 'overview';
  queryParams$: Observable<any> = of({});
  relationShipViewDetails: any[] = [];
  totalFeedCount = 0;
  currentUserDetails: any = {};
  firstRecevied: any;
  chart: any;
  lastRecevied: any;
  brandDetails = Helpers.brandDetails;
  isAvailableFirstIntraction = false;
  isAvailableLastIntraction = false;
  isAnyError = false;
  isSupported = true;
  errorCode: any = '';
  isDataAvailable = false;
  showLoader = true;
  promoter = 0;
  passive = 0;
  detractor = 0;
  NPSscore: any = 0;
  columns: any
  tableDataList: any[] = [];
  dates: any[] = [];
  ratings: any[] = [];
  relationshipData: number[] = [];
  isChartErrorShow: boolean = true;
  isAscendingOrder: boolean = false; // Track sorting order
  isCustomChart: boolean = false; // Default is false
  
  // Doughnut chart data
  doughnutData: {
    doughnutId: string;
    legendId: string;
    chartData: DoughnutChartData;
  } = {
      doughnutId: 'responseDoughnutChart',
      legendId: 'responseLegend',
      chartData: {
        header: '',
        names: [],
        data: [],
        color: ['#0B7139', '#D8790B', '#EC2524'], // Green, Yellow, Red
        total: 0
      }
    };   
  name: any;
  emailAddress: any;
  phoneNumber: any;
  customerId: any;
  colorObject: any;
  thirdColor: any;
  secondColor: any;
  firstColor: any;
  demovar: any;
  positiveCount: any;
  neutralCount: any;
  negativeCount: any;

  constructor(
    private responseAnalyticsService: ResponseAnalyticsService,
    private _verbatim: VerbatimService,
    private _helpers: HelpersService,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {
  }
  brandOffsetName = this._helpers.getBrandTimezoneDetails(this.brandDetails);
  lineChartData: any
  lineChartPlugins: any;
  ngOnInit(): void {
    this.loadRelationShipViewByUserId();
    // this.colorObject = Helpers.brandDetails.detailed_feedback_items[0]
    this.colorObject = Helpers.brandDetails.detailed_feedback_items.filter(function (el) {
     return el && el['field_id'] && el['field_id'] == 'primary_rating'
    })[0];
    this.firstColor = this.colorObject.prop[0].active_color
    this.secondColor = this.colorObject.prop[7].active_color
    this.thirdColor = this.colorObject.prop[9].active_color    
    
    this.brandDetails = (!_.isEmpty(this.brandDetails)) ? this.brandDetails : Helpers.brandDetails;
    if (_.get(this.brandDetails, "security_settings.tokenization_server.secret_key")) {
      this.isTSEnabled = true;
    }
    this.queryParams$ = this.route.queryParams.pipe(
      map(params => {
        this.activeTab = params['active_tab'] || 'customer_feedback';
        this.cdr.detectChanges();
        return params;
      })
    );

    this.lineChartPlugins = {
      lineColor: '#3777FF',
      gradientStartColor: '#fff',
      gradientEndColor: '#fff',
      borderWidth: 0,
      pointBorderWidth: 0,
      shadowColor: 'rgba(0, 4, 0, 0.6)',
      pointRadius: function (context) {
        // Check if there is only one data point
        const dataLength = context.chart.data.datasets[0].data.length;
        return dataLength === 1 ? 5 : 0; // Show dot with radius 5 if only one data point, otherwise no dot
      },

      pointBorderColor: '#ffffff',
      min: 0,
      max: 10,
      color: '#3777FF',
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: this.yAxisMin, // Use the input value here
            max: 12, // Set the maximum value of Y-axis
            ticks: {
              stepSize: 1, // Ensure the grid ticks are spaced by 1 unit
              callback: function (value: any) {
                return value; // Display the value as it is
              },
            },
          },
          x: {
            ticks: {
              color: this.xAxisFontColor, // Use the input value for font color
              font: {
                size: 13,
                family: 'Asap'
              }
            }
          }
        },
      },
    };
  }
  validateAndFormatDate(dateString: string): string {
    const parsedDate = moment(dateString, "ddd DD-MMM-YY HH:mm", true);
    if (!parsedDate.isValid()) {
      return "Invalid Date";
    }
    return parsedDate.format("YYYY-MM-DD HH:mm:ss"); // Convert to a reliable format
  }

  onFullScreen(event: any, templateRef: TemplateRef<any> | null): void {
    this.isFullScreen = !this.isFullScreen;
    this.fullScreenComponent = templateRef;
  }

  formatChartData(data: any): any {
    // Sort data by created_date in ascending order
    const sortedData = data.sort(
      (a: any, b: any) =>
        new Date(a.created_date).getTime() -
        new Date(b.created_date).getTime()
    );

    const labels = sortedData.map((item: any) =>
      moment(item.created_date).format("DD MMM 'YY") // Formats as "12 Feb 2025"
    );
    const ratings = data.map((item: any) => item.feed_params.primary_rating);
    return {
      labels, // x-axis (dates)
      data: ratings, // y-axis (ratings corresponding to sorted dates)
      xText: "Response Date",
      yText: "Rating",
    };
  }

  viewProfile(event: any, customerId: string) {


  }
  loadRelationShipViewByUserId(): void {
    const params = {};
    params['user_id'] = this.feedData['users'][0]['_id'];
    params['brand_id'] = this.feedData['feed']['brand_id'];
    params['feed_id'] = this.feedData['feed']['_id'];

    this.name = this.feedData['users'][0].name
    this.phoneNumber = this.feedData['users'][0].phone_number
    this.emailAddress = this.feedData['users'][0].email_address
    this.customerId = this.feedData['users'][0].tag_customer_id
    if (Helpers.hierarchyStack && Helpers.hierarchyStack[0] && Helpers.hierarchyStack[0]['field_id']) {
      params['hierarchy_stack[0][field_id]'] = Helpers.hierarchyStack[0]['field_id'];
      params['hierarchy_stack[0][group_key][0]'] = Helpers.hierarchyStack[0]['group_key'][0];
    } else {
      this.isSupported = false;
      this.showLoader = false;
      return;
    }

    this._verbatim.getRelationshipDetailByUserId(params).subscribe(
      (response: any) => {
        this.demovar = response.data.rating_distribution
        this.negativeCount = this.demovar.Detractor.doc_count
        this.neutralCount = this.demovar.Passive.doc_count
        this.positiveCount = this.demovar.Promotor.doc_count        
        
        if (response && response['code'] === 0 && response['data'] && response['data']['feeds']) {
          this.lineChartData = this.formatChartData(response.data.feeds);
          this.relationShipViewDetails = _.orderBy(response['data']['feeds'], ['created_date'], ['asc']);
          this.totalFeedCount = response['data']['total'];
          this.currentUserDetails = this.feedData['users'][0];
          this.preocessLastAndFirstReceived(this.relationShipViewDetails);
          this.prepareRatingScaleWithCount(this.relationShipViewDetails);
          this.prepareTableData(this.relationShipViewDetails);          
          this.prepareDoughnutChartData(this.relationShipViewDetails); // Populate doughnut chart
          this.relationshipData = this.responseAnalyticsService.segregateDataOnPercentage(response?.current);
          this.isChartErrorShow = response?.current?.doc_count === 0;
          this.isDataAvailable = true;
          this.showLoader = false; 
        } else {
          console.log('Error while getting user relationship details...');
        }
      },
      (error) => {
        console.error('Error in API call in CheckLogin:', error);
        this.showLoader = false;
        if (error && error.status === 404) {
          this.isAnyError = true;
          this.errorCode = error.status;
        } else if (error && error['name'] === 'HttpErrorResponse') {
          this.isAnyError = true;
          this.errorCode = 500;
        }
      }
    );
  }

  prepareDoughnutChartData(feeds: any[]): void {
    let positiveCount = 0;
    let neutralCount = 0;
    let negativeCount = 0;

    

    

    feeds.forEach((feed) => {
      const primaryRating = feed['feed_params']?.['primary_rating'];
      if (primaryRating >= 9) {
        positiveCount++;
      } else if (primaryRating >= 7 && primaryRating <= 8) {
        neutralCount++;
      } else if (primaryRating <= 6) {
        negativeCount++;
      }
    });
    const totalResponses = positiveCount + neutralCount + negativeCount;
    const positivePercentageString = ((positiveCount / totalResponses) * 100).toFixed(1);
    const neutralPercentageString = ((neutralCount / totalResponses) * 100).toFixed(1);
    const negativePercentageString = ((negativeCount / totalResponses) * 100).toFixed(1);

    if (totalResponses === 0) {
      this.doughnutData = {
        doughnutId: 'responseDoughnutChart',
        legendId: 'responseLegend',
        chartData: {
          header: `Total Responses: 0`,
          // totalResponses: 0, // Added total responses
          names: [`Positive (0%)`, `Neutral (0%)`, `Negative (0%)`],
          data: [0, 0, 0],
          percentageData: ['0', '0', '0'], // Ensure percentages are strings
          color: ['#0B7139', '#F8B316', '#EC2524'],
        }
      };
      return;
    }

    this.doughnutData = {
      doughnutId: 'responseDoughnutChart',
      legendId: 'responseLegend',
      chartData: {
        header: `Total Responses: ${totalResponses}`,
        names: [
          `Positive`,
          `Neutral`,
          `Negative`
        ],
        data: [positiveCount, neutralCount, negativeCount],
        percentData: [
          positivePercentageString,
          neutralPercentageString,
          negativePercentageString
        ],
        total: totalResponses || 13,
        color: ['#0B7139', '#F8B316', '#EC2524'],
      }
    };

  }

  toggleTab(tab: string): void {
    this.activeTab = tab;
  }

  getNpsClass(score: number): string {
    if (score >= -100 && score <= 20) {
      return 'light-red';
    } else if (score >= 21 && score <= 50) {
      return 'light-yellow';
    } else if (score >= 51 && score <= 100) {
      return 'light-green';
    }
    return '';
  }
  calculateNpsScore(feed, promoter, detractor) {
    const customer_promoter_percentage = (promoter / feed.length) * 100;
    const customer_detractor_percentage = (detractor / feed.length) * 100;
    this.NPSscore = ((customer_promoter_percentage) - (customer_detractor_percentage)).toFixed(2);
    if (this.NPSscore % 1 === 0) {
      this.NPSscore = Math.round(this.NPSscore);
    }
  }
  preocessLastAndFirstReceived(feed_details) {

    if (feed_details && feed_details.length > 0) {
      feed_details = _.sortBy(feed_details, function (dateObj) {
        return new Date(dateObj.created_date);
      });
      this.isAvailableFirstIntraction = true;
      this.firstRecevied = this._helpers.getTimeByOffset(
        this.brandOffsetName['__zone_symbol__value']['offset'],
        _.get(feed_details, '0.created_date'),
        "DD MMM 'YY HH:mm"
      );
      if (feed_details.length > 1) {
        this.isAvailableLastIntraction = true;
        this.lastRecevied = this._helpers.getTimeByOffset(
          this.brandOffsetName['__zone_symbol__value']['offset'],
          _.get(feed_details, feed_details.length - 1+'.created_date'),
          "DD MMM 'YY HH:mm"
        );
      }
    }
  }
  prepareTableData(feeds: any[]): void {

this.tableDataList = feeds.map(feed => {
  const primaryRating = feed['feed_params']?.['primary_rating'] ?? 'NA';
  // const tooltipText = primaryRating === 'NA'
  //   ? { primary_rating: 'No rating provided by the customer' }
  //   : {};

  return {
    'Request Date': this._helpers.getTimeByOffset(this.brandOffsetName['__zone_symbol__value']['offset'], _.get(feed, 'feedback_request_date'), "DD MMM 'YY : HH:mm"),
    'Responded Date': this._helpers.getTimeByOffset(this.brandOffsetName['__zone_symbol__value']['offset'], _.get(feed, 'created_date'), "DD MMM 'YY : HH:mm"),
    'Primary Rating': primaryRating,
    'Comments': feed['feed_params']?.['comments'] || 'No comment provided',
    'responded_date_timestamp': new Date(feed['created_date']).getTime(),
    'request_date_timestamp': new Date(feed['feedback_request_date']).getTime(),
    // tooltip_text: tooltipText
  };
});

    this.generateDynamicColunms(this.tableDataList);
    this.relationshipTimeline = this.tableDataList;

  }
  sortData(columnKey: string, isAscending: boolean): void {
    this.tableDataList = [...this.tableDataList].sort((a, b) => {
      const valueA = a[columnKey];
      const valueB = b[columnKey];

      if (!valueA || !valueB) return 0; // Prevents errors if values are null/undefined

      if (!isNaN(Date.parse(valueA)) && !isNaN(Date.parse(valueB))) {
        // If values are valid dates, sort them as dates
        return isAscending
          ? new Date(valueA).getTime() - new Date(valueB).getTime()
          : new Date(valueB).getTime() - new Date(valueA).getTime();
      } else if (typeof valueA === "number" && typeof valueB === "number") {
        // If values are numbers, sort numerically
        return isAscending ? valueA - valueB : valueB - valueA;
      } else {
        // Default: Sort as string
        return isAscending
          ? valueA.toString().localeCompare(valueB.toString())
          : valueB.toString().localeCompare(valueA.toString());
      }
    });

  }

  generateDynamicColunms(data: any[]): void {
  
    if (data.length > 0) {
      const sampleObject = data[0];  
      this.columns = Object.keys(sampleObject)
        .filter((key) => key !== 'responded_date_timestamp' && key !== 'request_date_timestamp') // Exclude these columns
        .map((key, index) => {
          let object: any = {
            header: key,
            dataKey: key,
            dataType: typeof sampleObject[key],
            order: index + 1,
            sorting: true,
            width: index === 0 ? '30%' : '20%',
            is_deviation_enabled: false,
            enabled: true,
            isColumnSorted: index === 1, // Ensure the second column is sorted
            isSelected: index === 1, // Mark the second column as selected (if applicable)
            ellipsisEnabled: true,
           style: {
            headerTextAlign: 'left',
            cellTextAlign: key === 'Primary Rating' ? 'right' : 'left', // ✅ RIGHT align for Primary Rating
          },
          };
  
          if (key == 'Responded Date') object.sortBy = 'responded_date_timestamp';
          if (key == 'Request Date') object.sortBy = 'request_date_timestamp';
  
          return object;
        });
  
    }
  }

  prepareRatingScaleWithCount(feeds: any[]): void {
    if (feeds && feeds.length > 0) {
      feeds.forEach((feed) => {
        if (feed && feed['feed_params'] && feed['feed_params']['primary_rating']) {
          if (feed['feed_params']['primary_rating'] >= 9) {
            this.promoter = this.promoter + 1;
          }
          if (feed['feed_params']['primary_rating'] >= 7 && feed['feed_params']['primary_rating'] <= 8) { // Fixed condition for passive ratings
            this.passive = this.passive + 1;
          }
          if (feed['feed_params']['primary_rating'] <= 6) {
            this.detractor = this.detractor + 1;
          }
          this.dates.push(feed['created_date']);
          this.ratings.push(feed['feed_params']['primary_rating']);
        }
      });
      this.calculateNpsScore(feeds, this.promoter, this.detractor);
    }
  }

  applyOpacity(color: string): string {
    if (color.startsWith('#')) {
      // Convert HEX to RGBA with 0.2 opacity
      let r = parseInt(color.substring(1, 3), 16);
      let g = parseInt(color.substring(3, 5), 16);
      let b = parseInt(color.substring(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, 0.2)`;
    }
    return color; // If it's already in rgba format, return as is
  }
  

  imageList: string[] = [
    'assets/images/happy.svg',
    'assets/images/happy.svg',
    'assets/images/happy.svg'
  ];
}
